import LabeledField from 'app/dodones/shared/fields/Labeled.jsx'

const NumberField = ({ field, onChange }) => {
  const changed = useCallback((e) => {
    onChange(field.slug, parseFloat(e.target.value))
  })

  return (
    <LabeledField field={field}>
      <input
        type="number"
        value={field.value || '0'}
        onChange={changed}
        className="input-sm w-50"
        step={field.step || 1}
      />
      {field.unit}
    </LabeledField>
  )
}

export default NumberField
